/**
 * Health API service
 * Handles health check and monitoring endpoints
 */
import { AxiosResponse } from 'axios';
import { BaseApiService } from './baseApi';
import { HEALTH } from '../../constants';
import { HealthResponse } from '../../types';
import { ServiceResult } from '../../types/common/api.types';

export class HealthApiService extends BaseApiService {
  async healthCheck(): Promise<ServiceResult<HealthResponse>> {
    return this.withErrorHandling(async () => {
      const response: AxiosResponse<HealthResponse> = await this.api.get(
        `${HEALTH}`
      );
      return response.data;
    });
  }
}
